module.exports = __webpack_public_path__ + "img/automation_workflow_icon.50c6ce87.svg";